const API_BASE =
  import.meta.env.VITE_API_URL || "https://app.neurospherevoiceai.com/api";

export type ActionItemStatus = "open" | "done" | "dismissed";

export type ActionItem = {
  id: string;
  customer_id: string;
  caller_phone: string;
  caller_name: string | null;
  text: string;
  status: ActionItemStatus;
  source_call_id: string | null;
  created_at: string;
  completed_at: string | null;
  assignee_id: string | null;
  assignee_name: string | null;
};

export class ActionItemsHttpError extends Error {
  status: number;

  constructor(status: number) {
    super(`HTTP ${status}`);
    this.name = "ActionItemsHttpError";
    this.status = status;
  }
}

export async function fetchActionItems(customerId: string | number): Promise<ActionItem[]> {
  const res = await fetch(`${API_BASE}/customers/${customerId}/action-items`, {
    credentials: "include",
  });
  if (!res.ok) throw new ActionItemsHttpError(res.status);
  const data = await res.json();
  const rawItems: any[] = Array.isArray(data) ? data : (data?.items ?? []);
  return rawItems.map((item) => ({
    id: item.id,
    customer_id: String(item.customer_id ?? customerId),
    caller_phone: item.caller_phone ?? "",
    caller_name: item.caller_name ?? null,
    text: item.text ?? "",
    status: (item.status ?? "open") as ActionItemStatus,
    source_call_id: item.source_call_id ?? null,
    created_at: item.created_at ?? "",
    completed_at: item.completed_at ?? null,
    assignee_id: item.assignee_id ?? null,
    assignee_name: item.assignee_name ?? null,
  }));
}
